import {
  HomeIcon,
  PencilRulerIcon,
  RefreshCwIcon,
  MapPinnedIcon,
  Building2Icon,
  MessagesSquareIcon,
  ClipboardListIcon,
  FileSignatureIcon,
  CalculatorIcon,
  HardHatIcon,
  KeyRoundIcon,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

// Lucide icon-name strings → components. Import only icons actually used.
export const iconMap: Record<string, LucideIcon> = {
  Home: HomeIcon,
  PencilRuler: PencilRulerIcon,
  RefreshCw: RefreshCwIcon,
  MapPinned: MapPinnedIcon,
  Building2: Building2Icon,
  MessagesSquare: MessagesSquareIcon,
  ClipboardList: ClipboardListIcon,
  FileSignature: FileSignatureIcon,
  Calculator: CalculatorIcon,
  HardHat: HardHatIcon,
  KeyRound: KeyRoundIcon,
};
